import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";

import { ImageSlide } from "./ImageSlide";

function TempImageCarousel() {
  return (
    <Container className="hero-img-container">
      <div className="padding-spacing">
        <Carousel>
          <Carousel.Item>
            <ImageSlide image="/images/2025-01.jpeg" />
          </Carousel.Item>
          <Carousel.Item>
            <ImageSlide image="/images/2025-02.jpeg" />
          </Carousel.Item>
          <Carousel.Item>
            <ImageSlide image="/images/2025-03.jpeg" />
          </Carousel.Item>
          <Carousel.Item>
            <ImageSlide image="/images/2025-04.jpeg" />
          </Carousel.Item>
          <Carousel.Item>
            <ImageSlide image="/images/2025-05.jpeg" />
          </Carousel.Item>
          <Carousel.Item>
            <ImageSlide image="/images/2025-06.jpeg" />
          </Carousel.Item>
        </Carousel>
      </div>
    </Container>
  );
}

export { TempImageCarousel };
